<template>
  <div v-if="visivel" class="notif-card card">
    <div class="notif-topo">
      <span class="notif-label">Notificações neste aparelho</span>
      <span class="notif-estado" :class="estado">{{ rotuloEstado }}</span>
    </div>

    <p class="notif-texto">{{ instrucao }}</p>

    <button v-if="estado === 'desligado'" class="btn-primary" :disabled="ocupado" @click="ativar">
      {{ ocupado ? 'Ativando...' : 'Ativar notificações' }}
    </button>
    <button v-else-if="estado === 'ligado'" class="btn-secondary" :disabled="ocupado" @click="desativar">
      Desativar neste aparelho
    </button>
  </div>
</template>

<script>
import api from '../../lib/api'

// Base64 url-safe -> Uint8Array, formato que o pushManager exige da chave VAPID.
function chaveParaBytes(base64) {
  const pad = '='.repeat((4 - base64.length % 4) % 4)
  const bruto = window.atob((base64 + pad).replace(/-/g, '+').replace(/_/g, '/'))
  return Uint8Array.from([...bruto].map(c => c.charCodeAt(0)))
}

function apelidoDoAparelho() {
  const ua = navigator.userAgent
  if (/iPhone/.test(ua)) return 'iPhone'
  if (/iPad/.test(ua)) return 'iPad'
  if (/Android/.test(ua)) return 'Android'
  if (/Macintosh/.test(ua)) return 'Mac'
  return 'Navegador'
}

export default {
  name: 'NotificacoesCard',
  data() {
    return { visivel: false, estado: 'desligado', ocupado: false, chavePublica: null }
  },
  computed: {
    rotuloEstado() {
      return { ligado: 'Ativas', desligado: 'Desligadas', instalar: 'Requer instalação', bloqueado: 'Bloqueadas' }[this.estado]
    },
    instrucao() {
      if (this.estado === 'instalar') {
        return 'No iPhone, toque em Compartilhar → Adicionar à Tela de Início e abra o painel por lá. O Safari só permite notificações em app instalado.'
      }
      if (this.estado === 'bloqueado') {
        return 'A permissão foi negada neste aparelho. Reative em Ajustes → Notificações antes de tentar de novo.'
      }
      if (this.estado === 'ligado') {
        return 'Este aparelho recebe um aviso a cada pagamento confirmado dos seus eventos.'
      }
      return 'Receba um aviso no aparelho a cada pagamento confirmado, mesmo com o painel fechado.'
    }
  },
  async mounted() {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return
    try {
      const { data } = await api.get('/push/config')
      if (!data.ligado) return
      this.chavePublica = data.chavePublica
      this.visivel = true
      await this.lerEstado()
    } catch { /* sem push configurado no servidor: o card simplesmente nao aparece */ }
  },
  methods: {
    aviso(message, type) {
      this.$toast.open({ message, type, position: 'top-right' })
    },
    // iOS so expoe notificacao para app aberto pela tela de inicio. Fora dai o
    // botao falharia sem explicacao, entao a instrucao toma o lugar dele.
    ehIosForaDoApp() {
      const ios = /iPhone|iPad|iPod/.test(navigator.userAgent)
      return ios && !window.navigator.standalone
    },
    async lerEstado() {
      if (this.ehIosForaDoApp()) { this.estado = 'instalar'; return }
      if (Notification.permission === 'denied') { this.estado = 'bloqueado'; return }
      const reg = await navigator.serviceWorker.ready
      const assinatura = await reg.pushManager.getSubscription()
      this.estado = assinatura ? 'ligado' : 'desligado'
    },
    async ativar() {
      this.ocupado = true
      try {
        const permissao = await Notification.requestPermission()
        if (permissao !== 'granted') { this.estado = 'bloqueado'; return }
        const reg = await navigator.serviceWorker.ready
        const assinatura = await reg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: chaveParaBytes(this.chavePublica)
        })
        const { endpoint, keys } = assinatura.toJSON()
        await api.post('/push/inscrever', { endpoint, keys, apelido: apelidoDoAparelho() })
        this.estado = 'ligado'
        this.aviso('Notificações ativadas neste aparelho', 'success')
      } catch {
        this.aviso('Não foi possível ativar as notificações', 'error')
      } finally {
        this.ocupado = false
      }
    },
    async desativar() {
      this.ocupado = true
      try {
        const reg = await navigator.serviceWorker.ready
        const assinatura = await reg.pushManager.getSubscription()
        if (assinatura) {
          await api.post('/push/desinscrever', { endpoint: assinatura.endpoint })
          await assinatura.unsubscribe()
        }
        this.estado = 'desligado'
      } catch {
        this.aviso('Não foi possível desativar', 'error')
      } finally {
        this.ocupado = false
      }
    }
  }
}
</script>

<style scoped>
.notif-card { display: flex; flex-direction: column; gap: 12px; margin-bottom: 20px; }
.notif-topo { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.notif-label { font-weight: 600; }
.notif-estado { font-size: 12px; padding: 2px 10px; border-radius: 999px; background: #eee; }
.notif-estado.ligado { background: #d8f5e0; color: #1b6b3a; }
.notif-estado.bloqueado { background: #fde2e1; color: #8b2320; }
.notif-texto { margin: 0; font-size: 14px; color: #666; }
.notif-card button { align-self: flex-start; }
</style>
